import { useMatchWindowMediaQuery } from '../utils'

const MOBILE_WHATSAPP_URL = 'whatsapp://send'
const WEB_WHATSAPP_URL = 'https://web.whatsapp.com/send'
const API_WHATSAPP_URL = 'https://api.whatsapp.com/send'

export const useWhatsapp = () => {
  const { isMD } = useMatchWindowMediaQuery()

  const phoneWhatsappUrl = isMD ? WEB_WHATSAPP_URL : MOBILE_WHATSAPP_URL

  const apiBaseWhatsappUrl = isMD ? API_WHATSAPP_URL : MOBILE_WHATSAPP_URL

  const redirectToWhatsapp = ({
    phone,
    openInNewTab = false,
    text = ''
  }: {
    phone?: string
    text?: string
    openInNewTab?: boolean
  }) => {
    const encodedPhone = encodeURIComponent(phone || '')
    const encodedText = encodeURIComponent(text)

    const url = phone
      ? `${phoneWhatsappUrl}?phone=${encodedPhone}&text=${encodedText}`
      : `${apiBaseWhatsappUrl}?text=${encodedText}`

    if (openInNewTab) {
      const newWindow = window.open(url, '_blank')
      if (newWindow) {
        newWindow.opener = null
      }
    } else {
      window.location.href = url
    }
  }

  const generateWhatsappUrl = ({
    text,
    phone
  }: {
    text: string
    phone?: string
  }) => {
    const encodedPhone = encodeURIComponent(phone || '')
    const encodedText = encodeURIComponent(text)

    return phone
      ? `${phoneWhatsappUrl}?phone=${encodedPhone}&text=${encodedText}`
      : `${apiBaseWhatsappUrl}?text=${encodedText}`
  }

  return { redirectToWhatsapp, generateWhatsappUrl }
}
